// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\CCardDetails\CoordinationCardDetailsResponse.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { CoordinationCard, CoordinationCardData, CoordinationCardOptions } from 'data/models/CoordinationCard';
import { CoordinationCardRights } from 'server/enums/Rights';

// CoordinationCardDetailsResponseData is the class that CoordinationCardDetailsResponse serializes to/from
export interface CoordinationCardDetailsResponseData {
    Id : number;
	
    CoordinationCard : CoordinationCardData | null;
	
    Rights : CoordinationCardRights;
}

// CoordinationCardDetailsResponseOptions is the class which may be passed to the CoordinationCardDetailsResponse constructor to define optional initial data values
export interface CoordinationCardDetailsResponseOptions {
    Id : number;
	
    CoordinationCard? : CoordinationCardOptions | null;
	
    Rights? : CoordinationCardRights;
}

export class CoordinationCardDetailsResponse {
    public Id : DataSignal<number>;
	
    public CoordinationCard : DataSignal<CoordinationCard | null>;
	
    public Rights : DataSignal<CoordinationCardRights>;

    constructor();
    constructor(data : CoordinationCardDetailsResponseOptions);
    constructor(data: CoordinationCardDetailsResponseOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
	    
        this.CoordinationCard = S.value<CoordinationCard | null>(null);
	    
        this.Rights = jsonableObservable(S.value<CoordinationCardRights>(data && data.Rights !== undefined ? data.Rights : 0));
    }

    static key(obj : CoordinationCardDetailsResponse) {
        return obj.Id();
    }
    
    static dataKey(obj : CoordinationCardDetailsResponseOptions) {
        return obj.Id;
    }

    static update(obj : CoordinationCardDetailsResponse, data : CoordinationCardDetailsResponseOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
	        
	        
            if (data.Rights !== undefined) obj.Rights(data.Rights);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/CoordinationCardDetailsResponse.ts